export default "__VITE_ASSET__QRejZj$n__"